import { ContensisManagementApiCtor } from '~/providers/ContensisManagementApi';
import { SourceCms, TargetCms } from '~/services';

export const mapCmsToManagementApiCtor = (
  cms: SourceCms | TargetCms,
  projectId: string
): ContensisManagementApiCtor => ({
  clientId: cms.clientId,
  clientSecret: cms.sharedSecret,
  username: cms.username,
  password: cms.password,
  refreshToken: cms.refreshToken,
  projectId,
  rootUrl: cms.url,
});
